/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Invite_Too_LateInputs */

const en_us2_invite_too_late = /** @type {(inputs: Invite_Too_LateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`An invite only counts in an account's first ${i?.days} days.`)
};

const pt_br2_invite_too_late = /** @type {(inputs: Invite_Too_LateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Um convite só conta nos primeiros ${i?.days} dias da conta.`)
};

const pt_pt2_invite_too_late = /** @type {(inputs: Invite_Too_LateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Um convite só conta nos primeiros ${i?.days} dias da conta.`)
};

/** @type {(inputs: Invite_Too_LateInputs) => LocalizedString} */
const es_419_invite_too_late = en_us2_invite_too_late;

/** @type {(inputs: Invite_Too_LateInputs) => LocalizedString} */
const fr_fr2_invite_too_late = en_us2_invite_too_late;

/** @type {(inputs: Invite_Too_LateInputs) => LocalizedString} */
const de_de2_invite_too_late = en_us2_invite_too_late;

/** @type {(inputs: Invite_Too_LateInputs) => LocalizedString} */
const it_it2_invite_too_late = en_us2_invite_too_late;

/**
* | output |
* | --- |
* | "An invite only counts in an account's first {days} days." |
*
* @param {Invite_Too_LateInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_too_late = /** @type {((inputs: Invite_Too_LateInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Too_LateInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_too_late(inputs)
	if (locale === "es-419") return es_419_invite_too_late(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_too_late(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_too_late(inputs)
	if (locale === "de-DE") return de_de2_invite_too_late(inputs)
	if (locale === "it-IT") return it_it2_invite_too_late(inputs)
	return en_us2_invite_too_late(inputs)
});
export { invite_too_late as "invite.too_late" }